// src/features/analytics/components/AnalyticsHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Analytics Foundation. Reuses the shared
 * PageHeader primitive (same contract every other feature's header
 * uses) and puts one disabled placeholder in the actions slot to
 * reserve visual space for a future "خروجی گزارش" action. It has no
 * click handler and does nothing yet — wiring it to a real export
 * flow is a later phase, not this one. Same pattern as
 * monitoring/components/MonitoringHeader.tsx and
 * audit/components/AuditHeader.tsx.
 */
export function AnalyticsHeader() {
  return (
    <PageHeader
      title="تحلیل‌ها"
      description="مشاهده گزارش‌های عملکرد، درآمد و رشد پلتفرم در یک نگاه."
      actions={
        <button
          type="button"
          disabled
          className="vania-analytics-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          خروجی گزارش
        </button>
      }
    />
  );
}
